/**
 * Where the user last left the map.
 *
 * Leaving Keşfet for a listing detail unmounts this component, so without this
 * every return trip resets to the whole of Turkey and throws away the area the
 * user had found. Kept in localStorage rather than the URL because the app is
 * installed to a home screen, where there is no address bar to carry it.
 */
const VIEW_KEY = 'ciftci.map.view';
/** Older than this and the saved position is not where the user is any more. */
const VIEW_TTL_MS = 24 * 60 * 60 * 1000;

export interface SavedView {
  lon: number;
  lat: number;
  zoom: number;
  at: number;
}

export const readSavedView = (): SavedView | undefined => {
  try {
    const raw = localStorage.getItem(VIEW_KEY);
    if (!raw) return undefined;
    const view = JSON.parse(raw) as SavedView;
    const fresh =
      Number.isFinite(view.lon) &&
      Number.isFinite(view.lat) &&
      Number.isFinite(view.zoom) &&
      Date.now() - view.at < VIEW_TTL_MS;
    return fresh ? view : undefined;
  } catch {
    // Private mode, cleared storage, or a shape from an older build.
    return undefined;
  }
};

export const writeSavedView = (view: SavedView): void => {
  try {
    localStorage.setItem(VIEW_KEY, JSON.stringify(view));
  } catch {
    // Storage being unavailable must never break panning.
  }
};
